<template>
    <validation-plan-templates-component 
        :activeValidationPlanTemplates="activeValidationPlanTemplates" 
        :archivedValidationPlanTemplates="archivedValidationPlanTemplates" 
        @viewValidationPlanTemplate="handleViewValidationPlanTemplate" 
        @editValidationPlanTemplate="handleEditValidationPlanTemplate" 
        @duplicateTemplate="handleDuplicateTemplate" @archiveValidationPlanTemplate="handleArchiveValidationPlanTemplate"
        @completeTemplate="handleCompleteTemplate"> 
    </validation-plan-templates-component>
</template>


<script>
import ValidationPlanTemplatesComponent from '@/components/template/ValidationPlanTemplatesComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "ValidationPlanTemplates",
    components: { ValidationPlanTemplatesComponent},
    computed: {
        ...mapGetters([
            'base_url', 'auth_header'
        ]),
    },
    data: function() {
        return {
            component_url: 'experiments/templates',
            activeValidationPlanTemplates: [],
            archivedValidationPlanTemplates: []
        }
    },
    methods: {
        ...mapMutations([
            'SET_BREADCRUMB'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },        
        getActiveValidationPlanTemplates: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeValidationPlanTemplates = response.data;
                    console.log("Active ValidationPlanTemplate json: ")
                    console.log(this.activeValidationPlanTemplates)
                })
                .catch(error => {
                    console.log("Something went wrong getting the ValidationPlanTemplate :", error.response.data);
                });
        },
        getArchivedValidationPlanTemplates: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=True`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.archivedValidationPlanTemplates = response.data;
                    console.log("Archived ValidationPlanTemplate json: ")
                    console.log(this.archivedValidationPlanTemplates)
                })
                .catch(error => {
                    console.log("Something went wrong getting the ValidationPlanTemplate :", error.response.data);
                });
        },
        handleViewValidationPlanTemplate: function(currentValidationPlanTemplate) {
            console.log('Validation plan view')
            console.log("handleViewValidationPlanTemplate: currValidationPlanTemplate is ", currentValidationPlanTemplate.name)
            this.$router.push({ name: "ViewValidationPlanTemplate", params: { id: currentValidationPlanTemplate.id } });
        },
        handleArchiveValidationPlanTemplate: function(archivedTemplate){
            axios
                .patch(`${this.base_url}${this.component_url}/${archivedTemplate.id}/archive/`,
                    {},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Validation Plan Successfully Archived:", archivedTemplate);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan Successfully Archived`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveValidationPlanTemplates()
                    this.getArchivedValidationPlanTemplates()
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan was not successfully Archived`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Validation Plan was not successfully Archived: ", error.response.data);
                    this.getActiveValidationPlanTemplates()
                    this.getArchivedValidationPlanTemplates()
                });
        },
        handleEditValidationPlanTemplate: function(currentValidationPlanTemplate) {
            console.log("handleEditValidationPlanTemplate: currMeth is ", currentValidationPlanTemplate.analytes)
            this.$router.push({ name: "EditValidationPlanTemplate", params: { id: currentValidationPlanTemplate.id } });
        },
        handleCompleteTemplate: function(currentTemplate) {
            axios
                .patch(`${this.base_url}${this.component_url}/${currentTemplate.id}/`,
                    {status: "COMPLETED"},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Template Successfully Completed:", currentTemplate);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Template Successfully Completed`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveValidationPlanTemplates();
                    this.getArchivedValidationPlanTemplates();
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Template was not successfully Completed`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Template was not successfully Completed: ", error.response.data);
                    this.getActiveValidationPlanTemplates();
                    this.getArchivedValidationPlanTemplates();
                });
        },
        handleDuplicateTemplate: function(currentTemplate) {        
            delete currentTemplate.id
            delete currentTemplate.archived
            delete currentTemplate.archivation_date
            delete currentTemplate.status 
            // console.log("handleDuplicateTemplate: currTemplate is ", currentTemplate)
            
            axios
                .post(
                    this.base_url + this.component_url,
                    currentTemplate,
                    { 
                        headers: this.auth_header 
                    }
                )
                .then(() => {
                    console.log("Validation Plan Successfully Duplicated!");
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan Successfully Duplicated!`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveValidationPlanTemplates()
                    this.getArchivedValidationPlanTemplates()
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan was not successfully Duplicated!`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Validation Plan was not successfully Duplicated!", error.response.data);
                    this.getActiveValidationPlanTemplates()
                    this.getArchivedValidationPlanTemplates()
                    
                });
        }
    },
    mounted: function(){
        this.setBreadcrumb()
        this.getActiveValidationPlanTemplates();
        this.getArchivedValidationPlanTemplates();
    }
}
</script>
